export default __webpack_public_path__ + "static/SuisseIntl-Book-20c5460f8108c0fb4387e7d5930f71be.woff";